enum PaymentDocumentType {
  RECEIPT = 'RECEIPT',
  RECEIPT_WITH_NO_DUE_DATE = 'RECEIPT_WITH_NO_DUE_DATE',
  REPORT = 'REPORT',
}

export default PaymentDocumentType;
